import { render, staticRenderFns } from "./RFEM.vue?vue&type=template&id=21cceb24&scoped=true"
import script from "./RFEM.vue?vue&type=script&lang=js"
export * from "./RFEM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cceb24",
  null
  
)

export default component.exports